import React, { useEffect, useState } from "react";
import { Card, Table, Row, Col, Spin, Alert, Typography } from "antd";
import {
  ShoppingOutlined,
  CoffeeOutlined,
  RestOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";

const { Title } = Typography;

// // Utility to check if the current time is before the given meal time
// const isBeforeMealTime = (mealTime) => {
//   const currentTime = moment();
//   const mealMoment = moment(mealTime, "hh:mm A");
//   return currentTime.isBefore(mealMoment);
// };

// OrderCard Component
const OrderCard = ({
  title,
  icon,
  totalOrders,
  // mealTime,
  orders,
  activeTab,
  setActiveTab,
  cardType,
  isLoading,
  isOrdersAvailable,
}) => (
  <Col xs={24} sm={12} lg={8}>
    <Card
      hoverable
      onClick={() => setActiveTab(activeTab === cardType ? null : cardType)}
      className="order-card"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: "1.2rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            {icon}
            <span>{title}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "#1890ff",
              fontSize: "1.5rem",
              fontWeight: "bold",
            }}
          >
            {/* <ShoppingOutlined style={{ marginRight: 8 }} /> */}
            {isOrdersAvailable ? (
              totalOrders
            ) : (
              <p
                style={{
                  color: "red",
                  fontSize: "0.7rem",
                  marginBottom: "0px",
                }}
              >
                List will appear soon
              </p>
            )}
          </div>
        </div>
      </div>
    </Card>
    {activeTab === cardType && (
      <Card style={{ marginTop: "1rem" }}>
        {!isOrdersAvailable ? (
          <p>List will appear soon</p>
        ) : (
          <OrderTable orders={orders} isLoading={isLoading} />
        )}
      </Card>
    )}
  </Col>
);

// OrderTable Component
const OrderTable = ({ orders, isLoading }) => {
  const columns = [
    {
      title: "User Name",
      dataIndex: ["User", "name"],
      key: "name",
      render: (text) => text || "Unknown User",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={orders}
      rowKey="name"
      pagination={{ pageSize: 5 }}
      size="small"
      loading={isLoading}
    />
  );
};

// Main Component
const OrderDisplay = () => {
  const [orderData, setOrderData] = useState({ breakfast: [], lunch: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [isOrdersAvailable, setIsOrdersAvailable] = useState(false);
  const [isOrdersAvailableForBreakfast, setIsOrdersAvailableForBreakfast] =
    useState(false);
  const [isOrdersAvailableForLunch, setIsOrdersAvailableForLunch] =
    useState(false);
  const [mealTimes, setMealTimes] = useState({
    breakfastTime: "",
    lunchTime: "",
  });
  const [currentDateTime, setCurrentDateTime] = useState(
    moment().format("LLLL")
  );

  useEffect(() => {
    // Update the current time every second
    const timer = setInterval(() => {
      setCurrentDateTime(moment().format("LLLL")); // Full date and time
    }, 1000);

    return () => clearInterval(timer); // Clear interval on component unmount
  }, []);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/common/orders/public-order-view`
      )
      .then((response) => {
        if (response.data.code === 404) {
          setIsOrdersAvailable(false);
        } else {
          setOrderData(response.data.data);
          // setMealTimes({
          //   breakfastTime: response.data.breakfastTime,
          //   lunchTime: response.data.lunchTime,
          // });
          // if (isBeforeMealTime(response.data.breakfastTime)) {
          //   setIsOrdersAvailableForBreakfast(false);
          //   setIsOrdersAvailableForLunch(false);
          // } else if (
          //   isBeforeMealTime(response.data.lunchTime) &&
          //   !isBeforeMealTime(response.data.breakfastTime)
          // ) {
          //   setIsOrdersAvailableForBreakfast(true);
          //   setIsOrdersAvailableForLunch(false);
          // } else {
          //   setIsOrdersAvailableForBreakfast(true);
          //   setIsOrdersAvailableForLunch(true);
          // }
          setIsOrdersAvailable(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setError("Failed to fetch order data.");
        setIsLoading(false);
      });
  }, []);

  if (error) {
    return (
      <div style={{ padding: "2rem" }}>
        <Alert message="Error" description={error} type="error" showIcon />
      </div>
    );
  }

  return (
    <div style={{ padding: "1rem" }}>
      <Row gutter={[16, 16]} justify="center" style={{ marginTop: "4rem" }}>
        <OrderCard
          title="Breakfast Orders"
          icon={<CoffeeOutlined style={{ marginRight: 8 }} />}
          totalOrders={orderData.breakfast?.totalOrders || 0}
          // mealTime={mealTimes.breakfastTime}
          orders={orderData.breakfast?.orders || []}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          cardType="breakfast"
          isLoading={isLoading}
          isOrdersAvailable={isOrdersAvailable}
        />
        <OrderCard
          title="Lunch Orders"
          icon={<RestOutlined style={{ marginRight: 8 }} />}
          totalOrders={orderData.lunch?.totalOrders || 0}
          // mealTime={mealTimes.lunchTime}
          orders={orderData.lunch?.orders || []}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          cardType="lunch"
          isLoading={isLoading}
          isOrdersAvailable={isOrdersAvailable}
        />
      </Row>
      <div
        style={{
          fontSize: "0.8rem",
          color: "black",
          display: "flex",
          justifyContent: "center",
          marginTop: "1rem",
        }}
      >
        {currentDateTime} {/* Display current date and time */}
      </div>
      <style jsx global>{`
        .order-card {
          transition: all 0.3s;
        }
        .order-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </div>
  );
};

export default OrderDisplay;
